import util from '../lib/util';
import * as DateUtil from '../lib/dateutils';
import newHRTimestamp from '../lib/picos/timestamp';
import type {uuid, SchemaField, EntitySchema} from "../@types/schema";
import Base from "./base";
import {genUUID} from "../lib/picos/uuids";
import type {EntityType} from "../@types/entity";
function getCurrentUserId() { return sessionStorage.getItem('userId'); }
function getCurrentFirmId() { return sessionStorage.getItem('firmId'); }
export const Direction = {
    Inbound: "I",
    Outbound: "O"
};
export type DirectionType = typeof Direction[keyof typeof Direction];
class Referral extends Base implements EntityType {
    referralId: uuid;
    referrer: uuid;
    referral: uuid;
    referee?: uuid | null;
    referredOn?: Date | null;
    contactedOn?: Date | null;
    hiredOn?: Date | null;
    notes?: string | null;
    extraInfo?: string | null;
    direction?: DirectionType | null;
    constructor(doc: typeof Referral | any) {
        super(doc);
        if (!doc) doc = {
            firmId: getCurrentFirmId(),
            addedBy: getCurrentUserId(),
            addedOn: newHRTimestamp(),
            status: "C",
            entityId: null,
            entityType: null,
            referralId: genUUID(),
            referrer: null,
            referral: null,
        };
        // @ts-ignore
        this.entityId = doc._entityId || doc.entityId || doc.entityid || '00000000-0000-0000-0000-000000000000';
        // @ts-ignore
        this.entityType = doc._entityType || doc.entityType || doc.entitytype || "referral";
        // @ts-ignore
        this.referralId = doc._referralId || doc.referralId || doc.referralid || genUUID();
        // @ts-ignore
        this.referrer = doc._referrer || doc.referrer || null;
        // @ts-ignore
        this.referral = doc._referral || doc.referral || null;
        // @ts-ignore
        this.referee = doc._referee || doc.referee || null;
        // @ts-ignore
        this.referredOn = DateUtil.timestampOnly(doc._referredOn) || DateUtil.timestampOnly(doc.referredOn) || DateUtil.timestampOnly(doc.referredon) || null;
        // @ts-ignore
        this.contactedOn = DateUtil.timestampOnly(doc._contactedOn) || DateUtil.timestampOnly(doc.contactedOn) || DateUtil.timestampOnly(doc.contactedon) || null;
        // @ts-ignore
        this.hiredOn = DateUtil.timestampOnly(doc._hiredOn) || DateUtil.timestampOnly(doc.hiredOn) || DateUtil.timestampOnly(doc.hiredon) || null;
        // @ts-ignore
        this.notes = doc._notes || doc.notes || null;
        // @ts-ignore
        this.extraInfo = doc._extraInfo || doc.extraInfo || doc.extrainfo || null;
        // @ts-ignore
        this.direction = util.trimRight(doc._direction) || util.trimRight(doc.direction) || null;
    }
    get id(): uuid { return this.referralId; }
    static DIRECTION_VALUES = ["I", "O"];
    static override getPkFields(): SchemaField[] { return [{"type":"uuid","required":true,"pk":true,"default":"__UUID__","comment":"Unique id for this referral"},{"type":"uuid","required":true,"pk":true,"base":true,"default":"__FIRM__","mergeStrategy":"immutable","comment":"Associated firm"}]; }
    toLowerCase() { return this.referralId; }
    static override getNonRefArrayFields(): string[] { return []; }
    static override getDefaultEntries(): Referral[] {
        return [];
    }
    static override getSchema(): EntitySchema {
        return Base.withBaseFields({
    entity: 'referral',
    table: 'REFERRAL',
    comment: 'A referral tracks the relationship between a referring contact (referrer), a prospective client lead being referred (referral), and, for outbound cases, the party they are being sent to (referee). It records whether the referral came into the firm or was sent out, and tracks lifecycle milestones such as when contact was made and whether the referred party ultimately hired the firm or the referred attorney.',
    fields: {
        referralId: {
            type: 'uuid',
            required: true,
            pk: true,
            default: '__UUID__',
            comment: 'Unique id for this referral'
        },
        // If a firm user, we still use their contactId, not their userId
        referrer: {
            type: 'uuid', required: true, comment: 'Contact who is doing the referring, could be a firm user or a general contact'
        },

        referral: {
            type: 'uuid',
            entityType: 'lead',
            required: true,
            comment: 'The lead being referred'
        },
        referee: {
            type: 'uuid',
            entityType: 'contact',
            comment: 'If someone at the firm is doing the referring, this is the person we are referring to'
        },
        referredOn: {
            type: 'timestamp', comment: 'The date of referral'
        },
        contactedOn: {
            type: 'timestamp', comment: 'The date the referral made contact, or null if never happened'
        },
        hiredOn: {
            type: 'timestamp', comment: 'Did the referral ultimately hire us/hire them?'
        },
        notes: {
            type: 'string', comment: 'Any clarifying notes on the referral'
        },
        extraInfo: {
            type: 'string', comment: 'Any additional details about this (outbound) referral'
        },
        // Transients
        direction: {
            type: 'char', values: ['I', 'O'], valueNames: ['Inbound', 'Outbound'], transient: true, comment: 'Inbound [I] or Outbound [O]?'
        },
    },
    maps: [
        {name: 'referral', keysFn: t => t.referral, presentFn: (t, k) => t.referral === k},
        {name: 'referee', keysFn: t => t.referee, presentFn: (t, k) => t.referee === k}
    ]
});
    }
}
export default Referral;
